exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.cell[data-v-2ddcdb35] {\n}\n.cell[data-v-2ddcdb35]:hover {\n  background-color: yellow;\n}\n.no-pointer[data-v-2ddcdb35] {\n  pointer-events: none !important;\n}\n", ""]);
